import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import logo from "../assets/logo-avellaneda.png";
import APIMensajeMUI from "componentes/APIMensajeMUI";
import TurnosForm from "admin/turnos/TurnosForm";
import CancelarTurno from "./CancelarTurno";
import axios from "helpers/API";
import { errorBackendMsg } from "helpers/helpers";
import VacunaAntirrabicaInfo from "externo/VacunaAntirrabicaInfo";
import { useHistory, useLocation } from "react-router";
import VerTurno from "./VerTurno";
import DetalleTurno from "admin/turnos/DetalleTurno";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyItems: "center",
    alignItem: "center",
    direction: "column",
    justify: "center",
    maxWidth: "100vw",
    height: "100vh",
    padding: 20,
  },
  // necessary for content to be below app bar
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
  },
}));

const PANTALLAS = {
  RESERVA: "RESERVA",
  CANCELAR_TURNO: "CANCELAR_TURNO",
  VACUNA_ANTIRRABICA: "VACUNA_ANTIRRABICA",
  VER_TURNO: "VER_TURNO",
};

function WebExterna() {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const [showVacunaAntirrabica, setShowVacunaAntirrabica] =
    React.useState(false);
  const [selector, setSelector] = React.useState(PANTALLAS.RESERVA);
  // API Mensaje
  const [mensajeError, setMensajeError] = React.useState("");
  const [showError, setShowError] = React.useState(false);
  // Vacuna
  const [textoVacuna, setTextoVacuna] = React.useState("");
  const [mostrarDetalle, setMostrarDetalle] = React.useState(false);
  const [nroDoc, setNroDoc] =  React.useState(false);
  const [nroTurno, setNroTurno] =  React.useState(false);

  React.useEffect(() => {
    getTextoVacuna();
    if (location.pathname == "/cancelarTurno") {
      setSelector(PANTALLAS.CANCELAR_TURNO);
    }
    if (location.pathname == "/verTurno") {
      setSelector(PANTALLAS.VER_TURNO);
    }
    if (location.pathname == "/") {
      setSelector(PANTALLAS.RESERVA);
    }
  }, []);

  const Render = () => {
    switch (selector) {
      case PANTALLAS.RESERVA:
        return (
          !mostrarDetalle ? (
            <Grid item md={12}>
              <TurnosForm
                turnoInterno={false}
                setMostrarDetalle={setMostrarDetalle}
                setNroDoc={setNroDoc}
                setNroTurno={setNroTurno}
              />
            </Grid>
          ) : (
            <DetalleTurno nroDoc={nroDoc} nroTurno={nroTurno} />
          )
        );
      case PANTALLAS.CANCELAR_TURNO:
        return <CancelarTurno volver={() => setSelector(PANTALLAS.RESERVA)} />;
      case PANTALLAS.VER_TURNO:
        return <VerTurno volver={() => setSelector(PANTALLAS.RESERVA)} />;
      case PANTALLAS.VACUNA_ANTIRRABICA:
        return (
          <VacunaAntirrabicaInfo
            textoVacuna={textoVacuna}
            volver={() => setSelector(PANTALLAS.RESERVA)}
          />
        );
      default:
        return (
          !mostrarDetalle ? (
            <Grid item md={12}>
              <Box p={1}>
                <Typography variant="h5">Reserva de turnos</Typography>
                <Typography variant="h6">
                  Complete el siguiente formulario
                </Typography>
              </Box>
              <TurnosForm
                turnoInterno={true}
                setMostrarDetalle={setMostrarDetalle}
                setNroDoc={setNroDoc}
                setNroTurno={setNroTurno}
              />
            </Grid>
          ) : (
            <DetalleTurno nroDoc={nroDoc} nroTurno={nroTurno} />
          )
        );
    }
  };

  const getTextoVacuna = () => {
    axios
      .post("/generales/vacuna/antirrabica/obtener", {})
      .then(function (response) {
        if (!response.data) {
          return;
        }
        if (response.data.datos) {
          setShowVacunaAntirrabica(true);
          setTextoVacuna(response.data.datos);
        }
      })
      .catch(function (error) {
        setMensajeError(errorBackendMsg(error));
      });
  };

  return (
    <>
      <div className={classes.root}>
        <Grid container spacing={5}>
          <Grid item md={4} style={{ backgroundColor: "#83c442" }}>
            <Box
              mt={2}
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <img src={logo} />
            </Box>
            <Box mt={5}>
              <div
                style={{
                  textAlign: "center",
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  textShadow: "2px 1px 2px #000000",
                }}
              >
                <p>1. Selecciona el trámite que necesitas realizar.</p>
                <p>
                  2. Elige un día del calendario y un horario que se encuentre disponible.
                </p>
                <p>
                  3. Completa los datos solicitados para obtener el turno solicitado.
                </p>
              </div>
            </Box>
            <Box mt={5}>
              <Button
                elevation={3}
                style={{
                  width: "100%",
                  backgroundColor: "#dd3948",
                  color: "white",
                }}
                variant="contained"
                onClick={() => { setMostrarDetalle(false); setSelector(PANTALLAS.CANCELAR_TURNO);  history.push("/cancelarTurno") }}
              >
                Cancelar Turno
              </Button>
            </Box>
            {showVacunaAntirrabica && (
              <Box mt={2}>
                <Button
                  elevation={3}
                  style={{
                    width: "100%",
                    backgroundColor: "#4973b3",
                    color: "white",
                  }}
                  variant="contained"
                  onClick={() => {setMostrarDetalle(false); setSelector(PANTALLAS.VACUNA_ANTIRRABICA);}}
                >
                  Vacunacion Antirrábica
                </Button>
              </Box>
            )}
          </Grid>
          <Grid item md={8} xs={12}>
            <>
              <APIMensajeMUI
                mt={10}
                tipo="error"
                showMensaje={showError}
                setShowMensaje={setShowError}
                msg={mensajeError}
              />

              <Render />
            </>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default WebExterna;
